import React from "react";

import "./styles.scss"
import DocResearch from "../esg-chat/doc-research";

const PrivateResearchMain = () => {
    return (
        <div className="private-research-main">
            <DocResearch />
        </div>
    )
}

export default PrivateResearchMain